<script lang="ts">
    import type {RecordStatusTransition} from 'src/typings';
    import type {Row} from '@tanstack/svelte-table';
    import type {HierarchicalRecordRow} from '../../lib/types';
    import type {RecordStatusTransitionButtonDefinition} from 'src/features/record/types';
    import type {RecordGridDataManager} from 'src/features/record-grid/lib/record-grid-data-manager';
    import {getInjector} from 'src/core';
    import {exists} from 'shared/utils/custom-utils';
    import RecordStatusService from 'src/features/record/record-status.service';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let recordGridDataManager: RecordGridDataManager;
    export let row: Row<HierarchicalRecordRow>;

    const recordStatusService = getInjector().getByClass(RecordStatusService);

    $: currentRecordRow = row.original;

    function getStatusTransitionButton(statusTransition: RecordStatusTransition): RecordStatusTransitionButtonDefinition {
        return recordStatusService.getStatusTransitionButton(currentRecordRow.status, statusTransition);
    }
</script>

<div class="kp-grid-control-cell">

    {#if currentRecordRow.editLockStatus.locked}
        <KpButton additionalClasses="add-new-row-btn"
                  buttonStyle="no-background"
                  buttonSize="xs"
                  tooltipLabel={`Záznam je zamčený${currentRecordRow.editLockStatus.cause ? ` - ${currentRecordRow.editLockStatus.cause.text}` : ''}. Odemknutí je ${currentRecordRow.editLockStatus.unlockPermission.allowed ? 'povolené' : `zakázané - ${currentRecordRow.editLockStatus.unlockPermission.reason.text}`}`}>
            <IconedContent icon="lock"
                           iconColor="var(--danger-red)">
            </IconedContent>
        </KpButton>
    {:else}
        <KpButton additionalClasses="add-new-row-btn"
                  buttonStyle="no-background"
                  buttonSize="xs"
                  tooltipLabel={`Záznam je odemčený k editaci${currentRecordRow.editLockStatus.cause ? ` - ${currentRecordRow.editLockStatus.cause.text}` : ''}. Uzamčení je ${currentRecordRow.editLockStatus.lockPermission.allowed ? 'povolené' : `zakázané - ${currentRecordRow.editLockStatus.lockPermission.reason.text}`}`}>
            <IconedContent icon="unlock">
            </IconedContent>
        </KpButton>
    {/if}

    {#each currentRecordRow.recordStatusTransitions as statusTransition}
        {@const statusTransitionButton = getStatusTransitionButton(statusTransition)}

        <KpButton additionalClasses="add-new-row-btn"
                  buttonStyle={statusTransitionButton.buttonStyle}
                  buttonSize="xs"
                  isDisabled={statusTransitionButton.disabled}
                  tooltipLabel={statusTransitionButton.title}
                  on:click={() => recordGridDataManager.changeStatus(row, statusTransition.targetStatus.id)}>

            <IconedContent icon={statusTransitionButton.icon}
                           iconColor={statusTransitionButton.iconsColor ?? undefined}>
                {#if statusTransitionButton.textAlwaysShown}
                    {statusTransitionButton.shortText}
                {/if}
            </IconedContent>
        </KpButton>
    {/each}

    {#if currentRecordRow.draft}
        <KpButton additionalClasses="add-new-row-btn"
                  buttonStyle="danger"
                  buttonSize="xs"
                  tooltipLabel="Smazat záznam"
                  on:click={() => recordGridDataManager.deleteRow(row)}>

            <IconedContent icon="trash"/>
        </KpButton>
    {/if}

    {#if exists($$slots.default)}
        <slot/>
    {/if}
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .kp-grid-control-cell {
        display: flex;
        overflow: hidden;
        height: 100%;
        gap: @spacing-xs;

        :global(.kp-button),
        :global(.kp-button-style-link),
        :global(.btn) {
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>